document.addEventListener("DOMContentLoaded", () => window.is__onload = true);
document.addEventListener("product:before:page:load", () => window.is__onload = false);

document.addEventListener("DOMContentLoaded", function () {
  const swatchContainer = document.querySelector('.product-swatch-options .swatches-container');

  if (swatchContainer) {
    const swatchLength = swatchContainer.getAttribute('data-color-length');
    const swatchToShow = swatchContainer.getAttribute('data-color-to-show');

    if (swatchLength && swatchToShow) {
      const display = Number(swatchLength) <= Number(swatchToShow) ? 'none' : 'flex';
      document.querySelectorAll('.moreless-button').forEach(function (el) {
        el.setAttribute('style', 'display: ' + display + ' !important');
      });
    }
  }
});

document.addEventListener("product:page:loaded", function () {
  const pdpConfig = window.__pdpConfig || {};

  if (pdpConfig.isProductTemplate) {
    const activeMultiColorElement = document.querySelector('.active[multi-color="true"]');
    const productID = activeMultiColorElement ? activeMultiColorElement.getAttribute('data-pro-id') : null;
    const variantID = pdpConfig.variantId;

    if (typeof clickpostForm !== 'undefined' && clickpostForm) {
      document.querySelectorAll('.product-variant-id').forEach(function (el) {
        el.value = variantID;
      });

      const productIdInput = clickpostForm.querySelector('input[name="product_id"]');
      if (productIdInput) {
        productIdInput.value = productID;
      }
    }

    if (typeof bindCustomEvents === 'function') bindCustomEvents();
  }

  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('variant')) onloadSizeDeselect();

  document.querySelectorAll('.categories-container .tab-title-container .title-block').forEach(function (element) {
    element.addEventListener('click', function () {
      if (this.parentElement) {
        Array.from(this.parentElement.children).forEach(function (sibling) {
          if (sibling !== element) {
            sibling.classList.remove('active');
          }
        });
      }

      this.classList.add('active');

      document.querySelectorAll('.tab-content-container .content-block').forEach(function (el) {
        el.classList.remove('active');
      });

      const tabId = this.getAttribute('tab-id');
      if (tabId) {
        const targetContent = document.querySelector('[content-tab-id="' + tabId + '"]');
        if (targetContent) {
          targetContent.classList.add('active');
        }
      }
    });
  });

  const firstTitleBlock = document.querySelector('.categories-container .tab-title-container .title-block:first-child');
  if (firstTitleBlock) {
    firstTitleBlock.click();
  }

  if (!window.is__onload) {
    document.querySelectorAll('.header__icon--account').forEach(function (element) {
      element.addEventListener('click', function () {
        document.querySelectorAll('.login-and-toolmenu').forEach(function (el) {
          el.classList.toggle('active');
        });
      });
    });
  }
}, { once: true });

document.addEventListener("DOMContentLoaded", onloadSizeDeselect);

function onloadSizeDeselect() {
  const selectSizeList = document.querySelectorAll('input[type="radio"][name="Size"]');
  const sizeHolder = document.querySelector('.selected-size-holder');

  if (selectSizeList.length > 0) {
    selectSizeList.forEach(function (select) { select.checked = false; });
    if (sizeHolder) sizeHolder.textContent = '';
    scrollFunction();
    document.querySelectorAll('.quick-size-warning').forEach(function (el) {
      el.style.display = 'none';
    });
  }
}

function scrollFunction() {
  function scrollAndTrigger(targetSelector, triggerCallback) {
    const target = document.querySelector(targetSelector);
    if (!target) return;

    const observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          triggerCallback();
          obs.disconnect();
        }
      });
    }, { threshold: 0.5 });

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    observer.observe(target);
  }

  const classContains = document.querySelector('.product-form__buttons .btn-trigger-event');
  const scrollTarget = document.querySelector('.product-form__buttons .btn-trigger-event.scroll_to_size');

  if (scrollTarget) {
    scrollTarget.addEventListener('click', function () {
      const activeClass = document.querySelector('.js.product-form__input .opt-dropdown');
      if (classContains && classContains.classList.contains('scroll_to_size')) {
        scrollAndTrigger('.other-opt-container fieldset.product-form__input', function () {
          if (window.matchMedia("(max-width: 749px)").matches) {
            activeClass.classList.add('active');
          }
        });
      }
    });
  }
}
